<template>
	<div v-if="!store.isLandingPage && !isMobile" class="relative">
		<img v-if="imgSource" class="h-full w-full object-cover" :src="imgSource" alt="" loading="lazy" />
	</div>
</template>

<script setup lang="ts">
import { store } from "@/state/store";
import useIsMobile from "@/services/detectingMobile";

const { isMobile } = useIsMobile();

defineProps<{
	imgSource: string | undefined;
}>();
</script>
